import Rest from '../Rest'

export default class SubscriptionPlanService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/subscription_plans'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findAllIntervals() {
    return this.get('/intervals')
  }

  findAllStatuses() {
    return this.get('/statuses')
  }

  // --- elegibilidade: quais aulas/modalidades o plano dá direito a usar ---

  getLessons(planId: number | string) {
    return this.get(`/${planId}/lessons`)
  }

  addLessons(planId: number | string, ids: Array<number>) {
    return this.post(`/${planId}/lessons`, { ids })
  }

  /**
   * Aulas que podem entrar neste plano. Endpoint próprio, e não o grid genérico
   * de aulas, porque a resposta depende do plano: o mesmo catálogo serve para
   * "1 por mês" e não serve para "3 por semana".
   */
  getLessonCandidates(planId: number | string, params: any = {}) {
    return this.get(`/${planId}/lesson_candidates`, params)
  }

  deleteLesson(planId: number | string, lessonId: number | string) {
    return this.delete(`/${planId}/lessons/${lessonId}`)
  }

  getModalities(planId: number | string) {
    return this.get(`/${planId}/modalities`)
  }

  addModalities(planId: number | string, ids: Array<number>) {
    return this.post(`/${planId}/modalities`, { ids })
  }

  deleteModality(planId: number | string, modalityId: number | string) {
    return this.delete(`/${planId}/modalities/${modalityId}`)
  }

  /** Assinantes do plano, cada um com a grade de horários fixos. */
  getSubscribers(planId: number | string) {
    return this.get(`/${planId}/subscribers`)
  }

  // --- onde o plano é vendido ---
  // Sem produto o plano não passa no filtro da vitrine e fica invisível; o
  // cadastro não mostrava isso em lugar nenhum.

  getProducts(planId: number | string) {
    return this.get(`/${planId}/products`)
  }

  addProduct(planId: number | string, productId: number | string) {
    return this.post(`/${planId}/products`, { product_id: productId })
  }
}
